<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardPopupImg
        :cardContent="content"
        :cardType="cardType2"
        :isModalVisible="isShow"
        @updateUser="updateUser"
      />
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import CardPopupImg from './components/CardPopupImg.vue';
import '../../../assets/scss/_chineseModalCustom.scss';
import '../../../assets/scss/_chineseStyle.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardPopupImg, LoadingMDL},
  name: 'LKI01',
  data() {
    return {
      code: '',
      lang: '',
      content: {},
      cardType2: 'img',
      isShow: true,
      CheckWidth: window.innerWidth.toString(),
      baseUrl: process.env.VUE_APP_URL_SOUND,
      sound: '',
      courseSection: '',
      startTime: '',
      courseCode: '',
      condition: [],
      navigate: {},
      loading: true,
      v3Data: {},
      nextPath: null,
    };
  },

  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];
      this.navigate = val.templates[0].content.item[0].navigate;

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      }

      this.checkNull();
      this.checkPicture();

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },
    saveContentStatusv4: function (val) {
      console.log(val, 'LKI01 Watcher Call');
      if (this.nextPath) {
        this.loading = true;
        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        // //to LTK 01
        this.$router.push(onNext);
      }
    },
  },

  mounted() {
    this.onLoad();
  },

  created() {},
  beforeDestroy() {},
  methods: {
    onLoad() {
      this.loading = true;

      this.lang = this.$store.state.language.language;
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.startTime = this.$helpers.getDateFormat();

      const contentId = `LKI01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkNull() {
      var data = this.content.content.item[0].title[0].value;
      if (data) {
        this.cardType2 = 'text';
      } else {
        this.cardType2 = 'img';
      }
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    updateUser(path) {
      const next = this.navigate.action;

      this.commitPayloadData(next);
    },
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    checkPicture() {
      var data = this.content.content.item[0].icon.enable.data;
      if (data === '/chinese/Image/ELEMENT/chest-open.png') {
        this.sound = '/chinese/Sound/Effect/Opening%20Chest/magic-wand.mp3';
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      } else if (data === '/chinese/Image/ITEM/paperroll/treasure-open.png') {
        this.sound = '/chinese/Sound/Effect/Opening%20Chest/magic-wand.mp3';
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      } else if (data === '/chinese/Image/ELEMENT/chest-closed.gif') {
        this.sound = '/chinese/Sound/Effect/Opening%20Chest/magic-wand.mp3';
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      } else if (data === '/chinese/Image/CHARACTER/FINAL/pegion_new.png') {
        this.sound = '/chinese/Sound/Effect/short-pigeon-wing-flap.mp3';
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      } else if (data === '/chinese/Image/ELEMENT/pegion_new.png') {
        this.sound = '/chinese/Sound/Effect/short-pigeon-wing-flap.mp3';
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      }
    },
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });
          this.nextPath = path;
        } else {
          //onNext
          const str = path.split('-');
          const nextPath = `/v4/${str[0]}/${str[1]}`;
          this.$router.push(nextPath);
        }
        //if not just clear stack
        // this.$store.commit('v4/clearPayloadStack');
      }
    },
  },
};
</script>
<style></style>
